import { useEffect, useState } from "react"

import { useChatInfo, useSetChatInfo } from "@shared/contexts"

import { Message } from "./useMessages"

interface Props {
  messages: Message[]
  isUser: boolean
  isActive: boolean
  isPartner?: boolean
}

export default function useCheckNewMessage({
  messages,
  isUser,
  isActive,
  isPartner = false,
}: Props) {
  const { hasNewMessage } = useChatInfo()
  const setChatInfo = useSetChatInfo()

  const [messageTimestamp, setMessageTimestamp] = useState<MessageTimestamp>({
    read: undefined,
    unread: undefined,
  })

  useEffect(() => {
    if (messages.length === 0 || isUser) return

    const { timestamp: newTime } = messages.slice(-1)[0]

    setMessageTimestamp(({ read: prevReadTime }: MessageTimestamp) => ({
      read: (!isPartner && isActive) || isActive ? newTime : prevReadTime,
      unread: newTime,
    }))
  }, [isActive, messages, hasNewMessage, isUser, isPartner])

  useEffect(() => {
    if (isUser) return

    const { read, unread } = messageTimestamp
    if (!unread || read === unread) return

    setChatInfo({
      type: "CHANGE_HAS_NEW_MESSAGE",
      hasNewMessage: true,
    })
  }, [messageTimestamp, setChatInfo, isUser])
}

interface MessageTimestamp {
  read: number | undefined
  unread: number | undefined
}
